import styled from 'styled-components';
import { Spacing16, Spacing32 } from 'autogen/design-tokens/tokens';
import type { MenuSectionViewModel } from 'autogen/swagger/all';
import { DefaultMenuSectionHeadline } from 'components/generic/menu/components/DefaultMenuSection';
import type { IMenuSection } from 'components/generic/menu/shared/types';
import { Typography } from 'components/generic/typography';

export const GreyCapitalHeadline = styled(Typography.Label)`
    font-weight: bold;
    color: ${({ theme }) => theme.ColorTextSecondary};
    margin: ${Spacing16} ${Spacing32};
`;

type SectionHeadlineRenderer = Pick<IMenuSection, 'headline'> & Pick<MenuSectionViewModel, 'headlineStyling'>;

export default function SectionHeadlineRenderer(props: SectionHeadlineRenderer) {
    const { headline, headlineStyling } = props;

    switch (headlineStyling) {
        case 'GreyCapital':
            return <GreyCapitalHeadline size="M">{headline}</GreyCapitalHeadline>;
        case 'Default':
            return <DefaultMenuSectionHeadline headline={headline} />;
        default:
            return null;
    }
}
